import { wplToken } from "@atlassiansox/wpl-token";
// eslint-disable-next-line no-restricted-imports
import { css } from "@emotion/react";
import { PropsWithChildren } from "react";

export const AppSwitcherMenu = ({ children }: PropsWithChildren) => (
    <div css={appSwitcherMenuStyles}>{children}</div>
);

const appSwitcherMenuStyles = css`
    display: block;
    position: absolute;
    border-radius: ${wplToken("space.075")};
    background-color: #ffffff;
    min-width: 160px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    padding: 0;
    z-index: 19;
    svg {
        margin-bottom: 0;
    }
    h1 {
        margin-top: ${wplToken("space.0")};
        font-weight: normal;
        font-weight: 500;
    }
    a {
        font-weight: 400;
    }
`;
